<template>
  <div class="wrapper" v-show="isVisible">
    <div class="fixed w-full h-full left-0 top-0 z-20" :class="$store.state.theme">
      <div class="w-full p-3 flex justify-end">
          <div class="minimize-button cursor-pointer hover:text-yellow-500" @click="isVisible = false">
            <icon icon="minus"/>
          </div>
        <div class="close-button cursor-pointer hover:text-red-500 ml-5" @click="closeEditor">
          <icon icon="times"/>
        </div>
      </div>
      <div class="flex justify-center items-center mt-5">
        <div class="editor lg:w-1/2">
          <editor
            ref="editor"
            :config="editorConfig"
            mode="wysiwyg"
            preview-style="vertical"
            @change="editorChanged"
            height="72vh"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@toast-ui/vue-editor/src/Editor.vue'
import editorConfig from '@/config/editor.js'
import { debounce, isEmpty } from 'lodash'
export default {
  components: { Editor },
  props: ['attribute'],
  data () {
    return {
      isVisible: false,
      editorConfig: editorConfig,
      content: ''
    }
  },
  methods: {
    closeEditor () {
      this.$emit('close')
      this.content = ''
    },
    editorChanged: debounce(function () {
      let content = this.$refs.editor.invoke('getMarkdown')
      if (isEmpty(this.attribute)) return
      this.$emit('update', content)
    }, 500)
  },
  watch: {
    content: debounce(function () {
      this.$emit('update', this.content)
    }, 500),
    attribute (newAttribute) {
      if (isEmpty(newAttribute)) {
        this.isVisible = false
        this.$refs.editor.invoke('setMarkdown', '')
        return
      }
      this.$refs.editor.invoke('setMarkdown', newAttribute.value)
      this.isVisible = true
      this.$nextTick(() => {
        this.$refs.editor.invoke('focus')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrapper {
  font-family: "Roboto Light", serif;
}
.editor {
  color: white;
}
</style>
